// extracted by mini-css-extract-plugin
export default {"detailsInput":"detailsInput_detailsInput__cVLhy"};